interface LineChartTickPoint {
    name: string;
}

interface ReportWidgetLineChartXAxisTickProps {
    x?: number;
    y?: number;
    payload?: { value?: string | number };
    index?: number;
    angle?: number;
    data: LineChartTickPoint[];
    formatter?: (
        label: string | number,
        index: number,
        data: LineChartTickPoint[],
    ) => string;
}

export const ReportWidgetLineChartXAxisTick = ({
    x,
    y,
    payload,
    index = 0,
    angle = 0,
    data,
    formatter,
}: ReportWidgetLineChartXAxisTickProps) => {
    if (typeof x !== 'number' || typeof y !== 'number') {
        return null;
    }

    const rawValue = payload?.value ?? '';
    const label = formatter
        ? formatter(rawValue, index, data)
        : String(rawValue);
    const isFirst = index === 0;
    const textAnchor = angle !== 0 ? 'end' : isFirst ? 'start' : 'middle';

    return (
        <text
            x={x}
            y={y}
            dy={16}
            textAnchor={textAnchor}
            fill="#000000"
            fontSize={12}
            transform={angle === 0 ? undefined : `rotate(${angle}, ${x}, ${y})`}
        >
            {label}
        </text>
    );
};
